import React from "react";
import Add_Products from "./Add_Products";

const Add_Products_Dynamic = () => <Add_Products useDynamicForm />;

export default Add_Products_Dynamic;
